/**
 * @copyright Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React, { Component } from 'react';
import {
    Route,
    Routes,
} from 'react-router-dom';
import ListsContainer from './ListsContainer';
import OrgViewListMatchReportContainer from './OrgViewListMatchReportContainer';

export default class ListsRouter extends Component {
    static propTypes = {

    };

    static defaultProps = {

    };

    render() { // eslint-disable-line
        return (
            <Routes>
                <Route path="/:id/view-match-report" element={<OrgViewListMatchReportContainer/>} />
                <Route path="/*" element={<ListsContainer/>} />
            </Routes>
        );
    }
}
